module.exports = __webpack_public_path__ + "img/no_certificate.bfb5f614.png";